import type { SVGProps } from 'react';

const SvgSupportLine = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		viewBox="0 0 24 24"
		data-at="svg-support-line"
		{...props}
	>
		<path d="M8 11a.97.97 0 0 0 .713-.288A.97.97 0 0 0 9 10a.97.97 0 0 0-.287-.713A.97.97 0 0 0 8 9a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 10q0 .424.287.712Q7.575 11 8 11m4 0a.97.97 0 0 0 .713-.288A.97.97 0 0 0 13 10a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 9a.97.97 0 0 0-.712.287A.97.97 0 0 0 11 10q0 .424.288.712A.97.97 0 0 0 12 11m4 0q.424 0 .712-.288A.97.97 0 0 0 17 10a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 9a.97.97 0 0 0-.712.287A.97.97 0 0 0 15 10q0 .424.288.712A.97.97 0 0 0 16 11M2 19.575V4q0-.825.588-1.413A1.93 1.93 0 0 1 4 2h16q.825 0 1.413.587Q22 3.175 22 4v12q0 .825-.587 1.413A1.93 1.93 0 0 1 20 18H6l-2.3 2.3q-.476.475-1.088.212Q2 20.25 2 19.575m2-2.4L5.175 16H20V4H4zM4 4v13.175z" />
	</svg>
);
export default SvgSupportLine;
